import type { EffectivePermission } from "../entities/AuthData";

export function canMatch(
  effectivePermissions: EffectivePermission[] | undefined,
  domain: string,
  action: string,
  resource: string
): boolean {
  if (!Array.isArray(effectivePermissions) || effectivePermissions.length === 0) {
    return false;
  }
  const d = domain.toUpperCase();
  const a = action.toUpperCase();
  const r = resource.toUpperCase();
  return effectivePermissions.some((p) => {
    const pd = (p.domain ?? "").toUpperCase();
    const pa = (p.action ?? "").toUpperCase();
    const pr = (p.resource ?? "").toUpperCase();
    const domainMatch = pd === "*" || pd === d;
    const actionMatch = pa === "*" || pa === a;
    const resourceMatch = pr === "*" || pr === r;
    return domainMatch && actionMatch && resourceMatch;
  });
}
